import { defineStore } from "pinia";
import { ref, reactive, computed } from "vue";
import { useRouter } from "vue-router";
import { useRequestsStore } from "@/stores/storeRequests";
import { useFieldsStore } from "./storeFieldData";
import { useModals } from "@/utils/useModals";

export const useDishesStore = defineStore("dishes", () => {
	const storeRequests = useRequestsStore();
	const storeField = useFieldsStore();
	const router = useRouter();
	const { openModal } = useModals();

	const loaderBtn = ref(false);

	const idDish = ref(1);

	const listDishes = reactive([
		{
			id: idDish.value,
			description: "",
			picture: "",
			photo_interior: "",
		},
	]);

	const addDish = () => {
		idDish.value++;
		listDishes.push({
			id: idDish.value,
			description: "",
			picture: "",
			photo_interior: "",
		});
	};

	const deleteDish = (id) => {
		const index = listDishes.findIndex((d) => d.id === id);
		if (index !== -1) {
			listDishes.splice(index, 1);
		}
		idDish.value--;
	};

	const isAllDishesValid = computed(() => {
		return (
			listDishes.length > 0 &&
			listDishes.every((dish) => dish.description.trim() !== "" && dish.picture !== "")
		);
	});
	const isAllExtraDishesValid = computed(() => {
		return (
			storeRequests.userData.survey?.dishes.length > 0 &&
			storeRequests.userData.survey?.dishes.every((dish) => dish.description.trim() !== "" && dish.photo_interior !== "")
		);
	});

	return {
		addDish,
		deleteDish,

		loaderBtn,
		listDishes,
		isAllDishesValid,
		isAllExtraDishesValid,
	};
});
